export enum CodeLayoutVariantEnum {
    DEFAULT = "default",
    ERROR = "error",
}

export enum GradientVariantEnum {
    ERROR = "error",
    LOADING = "loading",
}
